import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './TermsConditions.css';

const TermsConditions = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    loadTermsConditions();
  }, []);

  const loadTermsConditions = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: 'admin/settings'
      });

      if (response.data.status && response.data.data) {
        const termsConditions = response.data.data.terms_and_conditions || '';
        setContent(termsConditions);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Error loading terms & conditions:', error);
      toast.error('Failed to load terms & conditions');
      setIsLoader(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const response = await ApiService.request({
        method: 'PUT',
        url: 'admin/settings',
        data: {
          terms_and_conditions: content
        }
      });

      if (response.data.status) {
        toast.success('Terms & Conditions saved successfully!');
      } else {
        toast.error(response.data.message || 'Failed to save');
      }
      setSaving(false);
    } catch (error) {
      console.error('Error saving terms & conditions:', error);
      toast.error('Failed to save terms & conditions');
      setSaving(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'color', 'background', 'align'
  ];

  if (isLoader) {
    return <Loader />;
  }

  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/* Header */}
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <div className="d-flex align-items-center">
              <button 
                className="btn btn-icon btn-sm btn-light me-3"
                onClick={handleBack}
              >
                <i className="bi bi-arrow-left"></i>
              </button>
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                Terms & Conditions
              </h1>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button 
              className="btn btn-base"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div id="kt_app_content" className="app-content flex-column-fluid pt-0">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label fw-bold">Terms & Conditions Content</label>
                <p className="text-muted small">Edit the terms and conditions content using the rich text editor below.</p>
              </div>
              <div className="terms-editor-container">
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter terms and conditions content..."
                  style={{ minHeight: '500px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;

